import React from "react"
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from "react-redux"
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import { formatDinero } from "../../../utils/formatDinero"
const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
})

const TResumen = ({ tituloTabla, resumen }) => {
    const classes = useStyles()
    const sueldoBase = useSelector(store => store.cotizacion.sueldoBase)
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableBody>
                        <TableRow hover tabIndex={-1}>
                            <TableCell align="left">{`${tituloTabla}`}</TableCell>
                        </TableRow>
                        <TableRow hover tabIndex={-1}>
                            <TableCell align="left">{`Salario Base: ${formatDinero(sueldoBase.Valor_Parametro)}`}</TableCell>
                        </TableRow>
                        <TableRow hover tabIndex={-1}>
                            <TableCell align="left">{`Total Ventas: ${formatDinero(resumen.totalVentas)}`}</TableCell>
                        </TableRow>
                        <TableRow hover tabIndex={-1}>
                            <TableCell align="left">{`Porcentaje Comision: ${resumen.porcentaje}%`}</TableCell>
                        </TableRow>
                        <TableRow hover tabIndex={-1}>
                            <TableCell align="left">{`Comisión de este mes: ${formatDinero(resumen.comision)}`}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}
export default TResumen